<template>
  <div id="submitButton">
    <div id="buttonConsole">
      <li @click="openDialog" id="showSettings">Settings</li>
    </div>
    <div v-if="$store.state.show" class="backdrop" @click="closeDialog"></div>
    <transition name="dialog">
      <dialog open v-if="$store.state.show" class="dialog">
        <button @click="closeDialog" style="float:right" id="closeButton">
          <img src="../../assets/close.svg" />
        </button>
        <header id="dialogHeader">
          <settings></settings>
        </header>
      </dialog>
    </transition>
  </div>
</template>
<script>
import Settings from "./BackgroundImages.vue";
export default {
  components: { Settings },
  methods: {
    openDialog() {
      this.$store.state.show = true;
    },
    closeDialog() {
      this.$store.state.show = false;
    },
    showConsole() {
      this.$store.state.show = false;
      console.log("Hey!");
    },
  },
  mounted() {
    window.addEventListener("keyup", (ev) => {
      if (ev.keyCode === 27) {
        this.$store.state.show = false;
      }
    });
  },
};
</script>
<style lang="scss" scoped>
#closeButton {
  background: transparent;
  border: 0px;
  margin-right: 10px;
  margin-top: 10px;
  opacity: 1;
  transition: opacity 0.1s ease-out;
  img {
    width: 25px;
    height: 25px;
    @media screen and(max-width:500px) {
      width: 20px;
      height: 20px;
    }
  }
}
#closeButton:hover {
  transition: opacity 0.1s ease-in;
  opacity: 0.7;
}
#closeButton:active {
  box-shadow: inset 0 0 3vh red;
}
h4 {
  margin-top: 12px;
  @media screen and(max-width:500px) {
    margin-top: 0px;
  }
}

#buttonConsole {
  text-align: center;
  margin-top: 20px;
}
#showSettings {
  color: white;
  padding-right: 20px;
  font-size: 20px;
  &:hover {
    color: darkgray;
    transition: color 0.18s ease-in;
  }
  & {
    @media screen and (max-width: 450px) {
      font-size: 18px;
    }
  }
}

.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 10;
}

dialog {
  position: fixed;
  margin: 0vh 25vh;
  width: auto;
  z-index: 100;
  border-radius: 10px;
  border: none;
  box-shadow: 0 0 1vh black;
  padding: 0;
  overflow: hidden;
  background-color: white;
  @media screen and (max-width: 1154px) {
    margin: 0vh auto;
  }
}

#dialogHeader {
  padding-top: 26px;
  padding-bottom: 14px;
  border: none;
  background-color: darkcyan;
  color: white;
  width: 100%;
}

.dialog-enter-from,
.dialog-leave-to {
  opacity: 0;
  transform: scale(0.8);
}

.dialog-enter-active {
  transition: all 0.3s ease-out;
}

.dialog-leave-active {
  transition: all 0.3s ease-in;
}

.dialog-enter-to,
.dialog-leave-from {
  opacity: 1;
  transform: scale(1);
}
li {
  cursor: pointer;
}
</style>
